import { withInstall } from '@park-ui/utils'
import Option from '@park-ui/components/select/src/option.vue'
import OptionGroup from '@park-ui/components/select/src/option-group.vue'
import CigSelect from './src/select.vue'

export const ElCigSelect = withInstall(CigSelect, {
  Option,
  OptionGroup,
})

export default ElCigSelect
